import React from 'react';
import { Route, Switch } from 'react-router-dom';
import PrivateRoute from '../PrivateRoute';
import { Container } from './styles';

import AddEvent from '../../pages/AddEvent';
import AddPost from '../../pages/AddPost';
import EditEvent from '../../pages/EditEvent';
import EditPost from '../../pages/EditPost';
import EventDetail from '../../pages/EventDetail';
import EventPosts from '../../pages/EventPosts';
import EventPromoters from '../../pages/EventPromoters';
import TopHeader from '../TopHeader';
import MyEvents from '../../pages/MyEvents';
import PostDetail from '../../pages/PostDetail';
import Promoters from '../../pages/Promoters';
import EvaluatePromoters from '../../pages/EvaluatePromoters';
import Requests from '../../pages/Requests';
import Sidebar from '../Sidebar';
import NotFound from '../../pages/NotFound';

const Base = () => (
  <Container className="producer-panel">
    <TopHeader />
    <Sidebar />
    <div className="dashboard">
      <main>
        <Switch>
          <PrivateRoute exact path="/panel/" component={MyEvents} />
          <PrivateRoute exact path="/panel/events/:id" component={EventDetail} />
          <PrivateRoute exact path="/panel/events/:id/edit" component={EditEvent} />
          <PrivateRoute exact path="/panel/events/:id/posts" component={EventPosts} />
          <PrivateRoute exact path="/panel/events/:id/promoters" component={EventPromoters} />
          <PrivateRoute exact path="/panel/events/:id/evaluate" component={EvaluatePromoters} />
          <PrivateRoute exact path="/panel/create-event" component={AddEvent} />
          <PrivateRoute exact path="/panel/posts/:id" component={PostDetail} />
          <PrivateRoute exact path="/panel/posts/:id/edit" component={EditPost} />
          <PrivateRoute exact path="/panel/create-post" component={AddPost} />
          <PrivateRoute exact path="/panel/promoters" component={Promoters} />
          <PrivateRoute exact path="/panel/requests" component={Requests} />
          <Route component={NotFound} />
        </Switch>
      </main>
    </div>
  </Container>
);

export default Base;



// WEBPACK FOOTER //
// ./src/components/Base/index.js